export const blockIconsHardwareRouterNew = (
	<span className='material-symbols-outlined'>router</span>
);
